export async function loadHeaderFooter(
  headerMountPoint
) {
    const response = await (
        await fetch('/disruptions/headerFooter', {
            body: JSON.stringify({ useLiteHeader: true }),
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'POST'
        })
     ).json();
     
    if (headerMountPoint) {
        headerMountPoint.innerHTML = response.html;
    }

    const scriptElement = document.createElement('script');
    scriptElement.async = true;
    scriptElement.innerText = response.js;
    document.body.appendChild(scriptElement);
}
